import TermsProvider from "~providers/terms";
import DefinitionList from "~components/definition-list/definition-list";
import * as React from 'react';
export default {
  TermsProvider,
  DefinitionList,
  React
};